import { Component, Input } from '@angular/core';
import { PROGRESS_BAR_FULL } from '../../utils/club-trader-constant';
import { ProfileTrader } from '../../state-management/club-trader/trader.reducer';

@Component({
  selector: 'progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})

export class ProgressBarComponent {

  @Input() public profile: ProfileTrader;
  
  constructor() {
    /** */
  }

  public progressBarStarter () {
    const percentualBarLoader = (PROGRESS_BAR_FULL * this.profile.contractCurrentMonth) / this.profile.clubTrader.starter.minimum;

    if (percentualBarLoader === 0) return 0;
    
    return percentualBarLoader > PROGRESS_BAR_FULL ? PROGRESS_BAR_FULL : percentualBarLoader;
  } 

  public progressBarMaster () {
    const anotherMinimum = this.profile.clubTrader.starter.minimum;
    const percentualBarLoader = (PROGRESS_BAR_FULL * (this.profile.contractCurrentMonth - anotherMinimum)) / (this.profile.clubTrader.master.minimum - anotherMinimum);

    if (this.progressBarStarter() < PROGRESS_BAR_FULL || percentualBarLoader === 0 || this.profile.contractCurrentMonth <= this.profile.clubTrader.starter.minimum) return 0;

    return percentualBarLoader > PROGRESS_BAR_FULL ? PROGRESS_BAR_FULL :  percentualBarLoader;
  } 

  public progressBarVip () {
    const anotherMinimum = this.profile.clubTrader.master.minimum;
    const percentualBarLoader = (PROGRESS_BAR_FULL * (this.profile.contractCurrentMonth - anotherMinimum)) / (this.profile.clubTrader.vip.minimum - anotherMinimum);

    if (this.progressBarMaster() < PROGRESS_BAR_FULL|| percentualBarLoader === 0 || this.profile.contractCurrentMonth <= this.profile.clubTrader.master.minimum) return 0;

    return percentualBarLoader > PROGRESS_BAR_FULL ? PROGRESS_BAR_FULL :  percentualBarLoader;
  }


}
